





















































import Vue from "vue";

import {
  PromotionItemForm,
  PromotionItemStatus
} from "../forms/PromotionCreateForm";

export default Vue.extend({
  props: {
    value: {
      type: Array as () => PromotionItemForm[],
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean
    },
    isDisable: {
      type: Boolean
    },
    validations: {
      type: Object
    }
  },
  computed: {
    productOptions() {
      return [];
    },
    items: {
      get(): PromotionItemForm[] {
        return (this as any).value;
      },
      set(items: PromotionItemForm[]) {
        this.$emit("input", items);
      }
    },
    itemsError() {
      return (this as any).validations.$error
        ? "ต้องใส่สินค้าอย่างน้อย 1 รายการ และไม่สามารถเลือกสินค้าที่ไม่ได้อยู่ในร้านค้าได้"
        : "";
    }
  },
  methods: {
    async addItem(item: string) {
      const items = item.split(",").filter(e => e);

      const newItems = items
        .map(item => {
          const _item = item.split(":");
          return { sku: _item[0], quantity: _item[1] };
        })
        .reduce((unique, item) => {
          if (!this.items.find(e => e.sku == item.sku)) {
            return { ...unique, [item.sku]: item };
          }

          return unique;
        }, {});

      this.items = [
        ...this.items,
        ...Object.values(newItems).map((item: any) => {
          return {
            name: "",
            sku: item.sku,
            quantity: +item.quantity ? +item.quantity : 1,
            status: PromotionItemStatus.Init
          };
        })
      ];
      this.$emit("checkItem");
    },
    remove(item: any) {
      if (item.id) {
        this.$emit("removeItem", item.id);
      }
      this.items.splice(this.items.indexOf(item), 1);
      this.items = [...this.items];
      this.$emit("checkItem");
    },
    isItemLoading(status: PromotionItemStatus) {
      return (
        status === PromotionItemStatus.Loading ||
        status === PromotionItemStatus.Init
      );
    },
    isItemSuccess(status: PromotionItemStatus) {
      return status === PromotionItemStatus.Success;
    },
    isItemFail(status: PromotionItemStatus) {
      return status === PromotionItemStatus.Fail;
    }
  }
});
